var viewer_rtlignore_default = {
  "gallery_container": "YQBEz",
  "imageTitleContainer": "Y-BG-",
  "clickableItem": "_5FtiA",
  "prerender": "_7Ls7j",
  "expandContainer": "_6qcFP",
  "expandIcon": "JSS-d",
  "itemOverlay": "C33i9",
  "imageTitle": "H0CyR",
  "pointer": "Mp47f",
  "fadeIn": "_5bDz3",
  "changing_background": "HeqUv"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
